import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

// Resumen legible de website_analysis.schema.json — NUNCA el JSON crudo.
// Solo se muestran las señales booleanas que son true (chips), con
// nombre traducido — el resto (false/null) no aporta nada visualmente.
const SIGNAL_KEYS = [
  'has_whatsapp', 'has_online_booking', 'has_booking_platform', 'has_session_packs',
  'has_group_classes', 'has_schedule', 'has_multiple_professionals', 'owner_visible',
  'has_cancellation_sensitive', 'is_franchise', 'is_ecommerce_only', 'website_active',
  'has_instagram_link',
];

const CONFIDENCE_STYLES = {
  high: 'text-emerald-400',
  medium: 'text-amber-400',
  low: 'text-red-400',
};

export function WebsiteAnalysisSummary({ analysis }) {
  const { t } = useTranslation();

  if (!analysis) {
    return <p className="text-sm text-zinc-500">{t('aiLeadScanner.leadDetail.noAnalysisYet')}</p>;
  }

  const activeSignals = SIGNAL_KEYS.filter((key) => analysis.signals?.[key] === true);

  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-zinc-200">{t('aiLeadScanner.websiteAnalysis.title')}</h3>
        <span className={`text-xs font-medium ${CONFIDENCE_STYLES[analysis.confidence] || 'text-zinc-500'}`}>
          {t('aiLeadScanner.websiteAnalysis.confidence')}: {analysis.confidence || '—'}
        </span>
      </div>

      {analysis.excluded && (
        <div className="flex items-start gap-2 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2 mb-3">
          <AlertTriangle className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-red-400">
            {t('aiLeadScanner.websiteAnalysis.excluded')}: {analysis.excluded_reason || '—'}
          </p>
        </div>
      )}

      <p className="text-sm text-zinc-300 mb-3">{analysis.summary}</p>

      {activeSignals.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {activeSignals.map((key) => (
            <span
              key={key}
              className="text-xs bg-zinc-800 text-zinc-300 border border-zinc-700 rounded-full px-2.5 py-1"
            >
              {t(`aiLeadScanner.signals.${key}`)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
